
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"font-family":"sans-serif"}},[_c('path',{attrs:{"d":"M10.473 0L1.788.01C.683.01-.002.586 0 1.484l.02 10.673c.002.899.827 1.246 1.77 1.211l5.715-.013.003-1.173-5.762.006c-.26.006-.55-.32-.55-.653l.049-9.849c0-.243.256-.46.518-.46l8.713-.046zm6.273 7.429l.01 4.227c0 .244-.253.438-.518.44l-4.434.05c-.405-.01-.407-.029-.597.224L7.67 17.03c-.597.747.566 1.275.955.772l3.378-4.445 4.308.016c1.094-.007 1.682-.676 1.687-1.576L18 7.43z","overflow":"visible","paint-order":"markers stroke fill"}}),_c('path',{attrs:{"d":"M14.078 0a.589.572 0 00-.59.572.589.572 0 00.59.573h1.91L11.442 5.56a.589.572 0 000 .81.589.572 0 00.833 0l4.549-4.417v1.854a.589.572 0 00.587.573.589.572 0 00.59-.573V.572A.589.572 0 0017.41 0z","overflow":"visible"}})])])
          )
        }
      }
    